import request from '@/API/request';

// 新增申报资格
export function createQualification(data) {
  return request({
    url: '/resource/api/government-declare/qualification',
    method: 'post',
    data,
  });
}
// 新增补贴申请
export function createSubsidy(data) {
  return request({
    url: `/resource/api/government-declare/subsidy`,
    method: 'post',
    data
  });
}
// 新增绩效数据
export function createPerformance(data) {
  return request({
    url: '/resource/api/government-declare/performance',
    method: 'post',
    data,
  });
}
//获取绩效上报列表
export function getPerformance(data) {
  return request({
    url: '/resource/api/government-declare/performance/page',
    method: 'get',
    params: data,
  });
}
//获取资格上报列表
export function getQualificationApplication(data) {
  return request({
    url: '/resource/api/government-declare/qualification/page',
    method: 'get',
    params: data,
  });
}
//获取补贴申报列表
export function getSubsidy(data) {
  return request({
    url: '/resource/api/government-declare/subsidy/page',
    method: 'get',
    params: data,
  });
}
//获取公司下部门列表
export function getDepartments(id) {
  return request({
    url: `/auth/api/org/companies/${id}/departments`,
    method: 'get',
  });
}
//查询公司人员列表
export function getCompaniesUsers(companyId) {
  return request({
    url: `/auth/api/org/companies/${companyId}/users`,
    method: 'get',
  });
}
// 保存绩效草稿
export function saveDraft(data) {
  return request({
    url: '/auth/api/performance-assessments/draft',
    method: 'post',
    data,
  });
}
// 员工提交绩效
export function saveSubmit(data, id) {
  return request({
    url: `/auth/api/performance-assessments/${id}/submit`,
    method: 'post',
    data,
  });
}

//员工查询自己的绩效列表
export function getMine(params) {
  return request({
    url: `/auth/api/performance-assessments/mine`,
    method: 'get',
    params,
  });
}
//待我审核列表
export function getReview(params) {
  return request({
    url: `/auth/api/performance-assessments/pending-review`,
    method: 'get',
    params,
  });
}
//绩效详情
export function getAssessments(params, id) {
  return request({
    url: `/auth/api/performance-assessments/${id}`,
    method: 'get',
    params,
  });
}
// 提交打分到复核
export function reviewSubmit(data, id) {
  return request({
    url: `/auth/api/performance-assessments/${id}/review-submit`,
    method: 'post',
    data,
  });
}
// 绩效退回
export function reviewReject(data, id) {
  return request({
    url: `/auth/api/performance-assessments/${id}/reject`,
    method: 'post',
    data,
  });
}
